































































































































































































































































import moment from 'moment';
import { Vue, Prop, Component } from 'vue-property-decorator';
import TextFieldRowReadonlyInput from '@/shared/text-field/text-field-row-readonly-input.component.vue';
import toCurrency from '@/shared/directive/toCurrency';
import DateFormat from '@/shared/utils/date-format';
import toDocument from '@/shared/directive/toDocument';
import routeTo from '@/router/routeTo';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ContractsDetailed from '@/domain/billing/entity/billing-detailed-entitys.ts/contracts-detailed-entity';
import BillingService from '@/domain/billing/service/billing.service';
import UserBusinessUnitService from '@/domain/business-unit/service/business-unit.store';
import BillingInfoContentSummaryTable from './billing-info-content-summary-table.component.vue';
import BillingInfoContentItemsTable from './billing-info-content-items-table.component.vue';
import BillingInfoContentCalculationsTable from './billing-info-content-calculations-table.component.vue';
import BillingDetailed from '../../../domain/billing/entity/billing-detailed.entity';
import ItemsDetailed from '../../../domain/billing/entity/billing-detailed-entitys.ts/items-detailed.entity';
import BillingInfoModalLog from './billing-info-modal-log.component.vue';
import BillingPaymentLinks from './payment-link/billing-info-content-payment-link.component.vue';

@Component({
  components: {
    TextFieldRowReadonlyInput,
    BillingInfoContentSummaryTable,
    BillingInfoContentItemsTable,
    BillingInfoContentCalculationsTable,
    BillingInfoModalLog,
    BillingPaymentLinks,
    VbTooltipSlot,
  },
  filters: {
    dayMonthYear(date: string): string {
      if (date === undefined || date === '' || date === ' ' || date === null) return '-';
      return DateFormat.timestampToLocal(moment(date).format('YYYY-MM-DD'));
    },
    toCurrency,
    toDocument,
  },
})
export default class BillingInfoContent extends Vue {
  @Prop({
    required: true,
  })
  billing!: BillingDetailed;

  @Prop({
    required: false,
    default: '',
  })
  businessUnitId!: string;

  @Prop({
    type: ContractsDetailed,
    default: () => (ContractsDetailed.of({})),
  })
  contract!: ContractsDetailed;

  tab: any = null;

  tabArray: string[] = ['RESUMO', 'ITENS', 'CÁLCULOS'];

  invoiceLoading: boolean = false;

  showModalLog: boolean = false;

  logMessages: string[] = [];

  logCreatedDate: string = '';

  logModalKey = 0;

  currencyFormat: any = toCurrency;

  updateModalLogState(value: boolean): void {
    this.showModalLog = value;
    if (!value) {
      this.logModalKey += 1;
    }
  }

  openSystemLog(logSummary: any): void {
    this.logMessages = logSummary.summary;
    this.logCreatedDate = logSummary.createdDate;
    this.updateModalLogState(true);
  }

  competence(month: number, year: number): string {
    return DateFormat.fullMonthAndYear(`${month}/${year}`);
  }

  formatMonthYear(value): string {
    if (value) {
      return DateFormat.simpleMonthAndYear(value)
    }
    return '-';
  }

  get calculations(): object[] {
    const calculationsArray: object[] = [];
    this.billing.items.forEach((item: ItemsDetailed) => {
      const calculations: object[] = item.calculations;
      calculations.forEach((calculation: any) => {
        calculation.line = item.line;
        calculationsArray.push(calculation);
      });
    });
    return calculationsArray;
  }

  get totalValueCalculations(): number {
    let val: number = 0;
    this.calculations.forEach((calculation: any) => {
      val += this.calculateValueToPay(Number(calculation.value),
        calculation.discountedValue, calculation.feedValue);
    });
    return val;
  }

  private calculateValueToPay(value: number, discount: number, feed: number): number {
    if (!feed) feed = 0;
    const valueWithFeed = value + feed;
    if (!discount) return valueWithFeed
    if (valueWithFeed <= discount) return 0;
    return valueWithFeed - discount;
  }

  get invoiceLinkText(): string {
    return this.billing.invoiceNumber ? 'Visualizar Nota Fiscal' : 'Nota Fiscal Indisponível';
  }

  async getInvoiceUrl(): Promise<void> {
    this.invoiceLoading = true;
    try {
      const objectUrl = await BillingService.getInvoicePdf(
        this.businessUnitId, this.billing.invoiceId,
      );
      const win = window.open(objectUrl, '_blank');
      if (win) win.focus();
    } catch (err) {
      VbSnackbarService.handleHttpError(err);
    } finally {
      this.invoiceLoading = false;
    }
  }

  get isContractSameBussinesUnit(): boolean {
    return this.billing.items.every((item: ItemsDetailed) => item.businessUnitId
      === this.businessUnitId);
  }

  get businessUnitName(): string {
    return this.billing.items[0]?.businessUnitName || '';
  }

  goToContract(contractId: string): void {
    const route: any = {
      path: `/contract/${contractId}`,
    };
    routeTo(this.$router, route)
  }

  created(): void {
    if (UserBusinessUnitService.selectedBusinessUnit.enablePaymentLinkGeneration) {
      this.tabArray.push('LINKS DE PAGAMENTO');
    }
  }
}
